import { render, staticRenderFns } from "./Tvod.vue?vue&type=template&id=11d0a966&scoped=true&"
import script from "./Tvod.vue?vue&type=script&lang=js&"
export * from "./Tvod.vue?vue&type=script&lang=js&"
import style0 from "./Tvod.vue?vue&type=style&index=0&id=11d0a966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0a966",
  null
  
)

component.options.__file = "Tvod.vue"
export default component.exports